import React from 'react';
import { SectionDivider } from './ui/SectionDivider';
export function OpeningHook() {
  return <section className="bg-[#F5EDE0] py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-150">
      <div className="max-w-3xl mx-auto" data-id="element-151">
        <p className="mb-6 text-[#3D2E1F]" data-id="element-152">
          ¿Recuerdas cómo era despertar y simplemente poner los pies en el suelo
          sin pensarlo dos veces? Hoy, esos primeros pasos se sienten como
          caminar sobre cristales, y tus dedos parecen de madera, negándose a
          cerrarse por completo.
        </p>

        <p className="text-[#3D2E1F]" data-id="element-153">
          No es que tu cuerpo se esté "rompiendo". Es que el "aceite" natural de
          tus articulaciones se ha enfriado durante la noche. Pero existe una
          forma de encender el motor antes de siquiera salir de la cama.
        </p>

        <SectionDivider data-id="element-154" />
      </div>
    </section>;
}